export const ESG_MONTHLY_EXTRA_WIDGETS = [
  "kpi_progress",
  "scope_1",
  "scope_2",
] as const;

export type EsgMonthlyExtraWidgetId = (typeof ESG_MONTHLY_EXTRA_WIDGETS)[number];

export const DEFAULT_ESG_MONTHLY_EXTRA_WIDGETS: EsgMonthlyExtraWidgetId[] = [
  ...ESG_MONTHLY_EXTRA_WIDGETS,
];

export const ESG_SCOPES_WIDGETS = ["scope_1", "scope_2", "breakdown"] as const;

export type EsgScopesWidgetId = (typeof ESG_SCOPES_WIDGETS)[number];

export const DEFAULT_ESG_SCOPES_WIDGETS: EsgScopesWidgetId[] = [...ESG_SCOPES_WIDGETS];

export const ESG_BRANCHES_WIDGETS = [
  "total_waste",
  "carbon_avoided",
  "fill_reports",
  "scope_1",
  "scope_2",
  "training_hours",
  "carbon_by_stream",
  "utilities",
] as const;

export type EsgBranchesWidgetId = (typeof ESG_BRANCHES_WIDGETS)[number];

export const DEFAULT_ESG_BRANCHES_WIDGETS: EsgBranchesWidgetId[] = [...ESG_BRANCHES_WIDGETS];

export const ESG_CARBON_WIDGETS = [
  "total_avoided",
  "weight_diverted",
  "completed_runs",
  "skipped_runs",
  "stream_chart",
  "stream_table",
  "material_table",
] as const;

export type EsgCarbonWidgetId = (typeof ESG_CARBON_WIDGETS)[number];

export const DEFAULT_ESG_CARBON_WIDGETS: EsgCarbonWidgetId[] = [...ESG_CARBON_WIDGETS];
